import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

// NOTE: this config and the one in public/firebase-messaging-sw.js must stay in
// sync, and both must name the same Firebase project as the backend's
// utils/fireBase.json service account. FCM tokens are project-scoped: if the
// client mints a token against project A while the server sends with project B's
// credential, every send fails with a SenderId mismatch / token-not-registered.
export const firebaseConfig = {
  apiKey: "AIzaSyBbOSkETbp1VHDyg1PLM6nYkqgEApLRooo",
  authDomain: "mywsh-38020.firebaseapp.com",
  projectId: "mywsh-38020",
  storageBucket: "mywsh-38020.firebasestorage.app",
  messagingSenderId: "714277231060",
  appId: "1:714277231060:web:e8cb29a0717723cdabde41",
  measurementId: "G-F096JL0JVH"
};

// Web Push certificate (Project settings → Cloud Messaging → Web Push
// certificates). Belongs to the same project as firebaseConfig above.
export const VAPID_KEY =
  "BM75mSwJCiNvnsSsfVQ1qbnA6e_7t0Kp6TJktqzYiEHEsLUJe_O-Bnr2Ad126dELUMnNOeKn8mYlDnP5xDtYuIw";

const app = initializeApp(firebaseConfig);

// Initialize messaging instance safely
let messaging = null;

export const getMessagingInstance = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      if (!messaging) {
        messaging = getMessaging(app);
      }
      return messaging;
    }
  } catch (err) {
    console.error("Firebase messaging not supported:", err);
  }
  return null;
};

export { messaging };